import { supabase } from '../supabaseClient';
import { fetchEventLineup } from '../api/artistVotes';
import { queryKeys } from './query/queryKeys';
import { STALE } from './query/staleTimes';
import { isFestivalEvent } from '../utils/eventType';

/**
 * After you mark Going on a festival ("just me"), its Sets page is where you make your picks (Sam, 2026-11-01). Only
 * when there is a lineup: an empty Sets page ("No lineup announced yet") right after Going is a dead end. `isFestival`
 * is looked up when the caller does not know it. Any failure stays put: you are still going.
 */
export async function openFestivalPicks({ queryClient, navigate, eventId, isFestival, backTo }) {
  try {
    if (isFestival === undefined) {
      const { data } = await supabase
        .from('events')
        .select('event_type')
        .eq('event_id', eventId)
        .maybeSingle();
      isFestival = isFestivalEvent(data);
    }
    if (!isFestival) return;
    const lineup = await queryClient.ensureQueryData({
      queryKey: queryKeys.events.lineup(eventId),
      queryFn: () => fetchEventLineup(eventId),
      staleTime: STALE.semiStatic,
    });
    if (!lineup?.length) return;
    navigate(`/sets/${encodeURIComponent(eventId)}`, backTo ? { state: { backTo } } : undefined);
  } catch {
    // Offline or refused: the event page's lineup card opens Sets later.
  }
}
